"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.sourceType.group': '群组',
    'whatsapp.sourceType.dm': '私信',
    'whatsapp.sourceType.email': '邮件',
};
